<h2>[{{course.courseId}}] {{course.name}} ({{course.term.id}})</h2>
<h3>[{{unit.classType.id}}] {{unit.classType.description}} <ng-container i18n>grupa</ng-container> {{classgroup.number}}</h3>


<a [routerLink]="['../..']" i18n>powrót</a>

<table id="classgroup-table" class="grey">
  <tbody class="autostrong">
  <tr>
    <td i18n>Kod przedmiotu</td>
    <td>{{course.courseId}}</td>
  </tr>
  <tr>
    <td i18n>Nazwa przedmiotu</td>
    <td>{{course.name}}</td>
  </tr>
  <tr *ngIf="course.language">
    <td i18n>Język wykładowy</td>
    <td>{{course.language?.name}}</td>
  </tr>
  <tr>
    <td i18n>Cykl dydaktyczny</td>
    <td>{{course.term.description}}</td>
  </tr>
  <tr>
    <td i18n>Typ zajęć</td>
    <td>{{unit.classType.description}}</td>
  </tr>
  <tr>
    <td i18n>Liczba godzin</td>
    <td>{{unit.hourCount}}</td>
  </tr>
  <tr>
    <td i18n>Punkty ECTS</td>
    <td>{{course.credits.default}}</td>
  </tr>
  <tr *ngIf="classgroup.lecturers.length > 0">
    <td i18n>Prowadzący</td>
    <td>
      <div *ngFor="let lecturer of classgroup.lecturers">
        <app-badge [user]="lecturer"></app-badge>
      </div>
    </td>
  </tr>
  <tr *ngIf="classgroup.weeklyMeetings.length > 0">
    <td i18n>Miejsce</td>
    <td>
      <div *ngFor="let meeting of classgroup.weeklyMeetings">
        <ng-container *ngIf="meeting.room">
          {{meeting.room.building?.name}},
          <ng-container *ngIf="meeting.room.building?.address">
          {{meeting.room.building?.address?.city}},
          {{meeting.room.building?.address.street}}
          {{meeting.room.building?.address.houseNumber}},
          </ng-container>
          sala {{meeting.room.number}}
          <a target="_blank" [href]="meeting.room.building?.usoswebURL" i18n>Pokaż na mapie - w osobnej karcie</a>
        </ng-container>
      </div>
  </tr>
  <tr *ngIf="classgroup.weeklyMeetings.length > 0">
    <td i18n>Termin</td>
    <td>
      <div *ngFor="let meeting of classgroup.weeklyMeetings">
        {{meeting.weeklyMeetingOption.day | dayOfWeek}}
        {{meeting.weeklyMeetingOption.hourBegin | number: '2.0-0' }}:{{meeting.weeklyMeetingOption.minuteBegin | number: '2.0-0' }}
        - {{meeting.weeklyMeetingOption.hourEnd | number: '2.0-0' }}:{{meeting.weeklyMeetingOption.minuteEnd | number: '2.0-0' }}
      </div>
    </td>
  </tr>
  <tr>
    <td i18n>Koszt</td>
    <td>
      {{unit.tokens.count}} &times; {{unit.tokens.tokenTypeId}}
      <!--      TODO: cena -->
    </td>
  </tr>
  <tr>
    <td i18n>Liczba miejsc (zarejestrowani/limit)</td>
    <td>{{registeredCount}} / {{classgroup.capacity}}</td>
  </tr>
  <tr *ngIf="classgroup.dedications.length > 0">
    <td i18n>Grupy dedykowane</td>
    <td>
      <ul>
        <li *ngFor="let dedication of classgroup.dedications">
          <span *ngIf="dedication.programme">
            {{dedication.programme.id}} {{dedication.programme.description}}
          </span>
          <span *ngIf="dedication.sex === 'Male'">
            Grupa dla mężczyzn
          </span>
          <span *ngIf="dedication.sex === 'Female'">
            Grupa dla kobiet
          </span>
        </li>
      </ul>
    </td>
  </tr>
  <tr *ngIf="registration.upcomingRound()">
    <td i18n>Aktualna tura</td>
    <td *ngFor="let round of [registration.upcomingRound()]">
      {{round.name}}, od {{round.dateFrom}},
      do: {{round.dateTo}},
      limit wydanych żetonów:
      <ng-container *ngFor="let tokens of round.tokens">{{tokens.count}} &times; {{tokens.tokenTypeId}}</ng-container>
    </td>
  </tr>
  <tr>
    <td i18n>Strona przedmiotu (otworzy się w nowej karcie)</td>
    <td>
      <a target="_blank"  [href]="course.usoswebUrl()">{{course.usoswebUrl()}}</a>
    </td>
  </tr>
  <tr>
    <td i18n>Tryb rozliczania przedmiotu</td>
    <td>{{course.reportType.description}}</td>
  </tr>
  <tr *ngIf="course.notes?.pl">
    <td i18n>Uwagi</td>
    <td><span [innerHTML]="course.notes.toStringWithNewlines()"></span></td>
  </tr>
  <tr *ngIf="classgroup.description?.pl">
    <td i18n>Dodatkowe informacje</td>
    <td><span [innerHTML]="classgroup.description.toStringWithNewlines()"></span></td>
  </tr>
  <tr *ngIf="classgroup.bibliography?.pl">
    <td i18n>Literatura</td>
    <td><span [innerHTML]="classgroup.bibliography"></span></td>
  </tr>
  </tbody>
</table>

<a [routerLink]="['../..']" i18n>powrót</a>
